module.exports = "<card>\r\n\t<menu-list [(placeId)]=\"place.id\" [(menus)]=\"place.menus\" [(copyList)]=\"copyList\"></menu-list>\r\n</card>\r\n"